export default __webpack_public_path__ + "static/About-Us-Featured-bd753ce666419f08d735cbfc4df5e70f.jpeg";